import React from 'react';
import { PhoneIcon, MessageCircleIcon } from 'lucide-react';
export function StickyBottomBar() {
  return <div className="fixed bottom-0 left-0 right-0 z-50 bg-[#f97316] text-white py-3 px-4 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] md:hidden" data-id="element-159">
      <div className="flex gap-2" data-id="element-160">
        <a href="tel:0523552222" className="flex-1 bg-white text-[#f97316] py-3 rounded-lg font-bold text-center flex items-center justify-center gap-1.5 shadow-sm active:bg-gray-100 text-sm" data-id="element-161">
          <PhoneIcon className="w-4 h-4 flex-shrink-0" data-id="element-162" />
          <span data-id="element-163">052-355-2222</span>
        </a>
        <a href="tel:0545188888" className="flex-1 bg-white text-[#f97316] py-3 rounded-lg font-bold text-center flex items-center justify-center gap-1.5 shadow-sm active:bg-gray-100 text-sm" data-id="element-164">
          <PhoneIcon className="w-4 h-4 flex-shrink-0" data-id="element-165" />
          <span data-id="element-166">054-518-8888</span>
        </a>
      </div>
    </div>;
}